import Vue from 'vue'
import ToastComponent from './Toast.vue'

let toastInstance = null

export function Toast({ content = '', message = '', bottom = '', duration = 3000 } = {}) {
  if (!content && !message) {
    console.warn('[Toast] 请至少传入 content 或 message')
    return
  }

  // 清除上一个实例
  if (toastInstance) {
    toastInstance.$destroy()
    toastInstance.$el.parentNode && toastInstance.$el.parentNode.removeChild(toastInstance.$el)
    toastInstance = null
  }

  const ToastConstructor = Vue.extend(ToastComponent)
  const instance = new ToastConstructor({
    propsData: { content, message, bottom, duration }
  })

  instance.$mount()
  document.body.appendChild(instance.$el)
  toastInstance = instance
}
